// Clients can be created without an email. The database still needs one
// (users.email is NOT NULL UNIQUE), so the server stores a placeholder on
// the reserved @contact.local domain. Nothing is ever sent there, and the
// UI shows it as "no email" instead of the placeholder.
export const PLACEHOLDER_DOMAIN = '@contact.local';
export const isPlaceholderEmail = (e) => !!e && String(e).toLowerCase().endsWith(PLACEHOLDER_DOMAIN);
export const displayEmail = (e, fallback = '') => (isPlaceholderEmail(e) ? fallback : (e || fallback));
